export const EMAIL = "annettesoftware@gmail.com";

export const DAS_TEAM = "team-section";
export const PORTFOLIO = "portfolio";
export const TERMIN_PLAN = "terminplan";